// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__22XdK","productName":"Table_productName__3EnEW"};